import { TooltipTrigger } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { useChatInputStore } from '~/stores/use-chat-input/useChatInput';

import { ChatInputConfig } from '../../chat-input';
import * as S from './ChatSubmitButton.styles';

export interface ChatSubmitButtonProps {
  isMessagePending: boolean;
  inputValue: string;
  abortRequest?: () => void;
  config?: ChatInputConfig;
}

export const ChatSubmitButton = ({
  isMessagePending,
  inputValue,
  abortRequest,
  config,
}: ChatSubmitButtonProps) => {
  const { t } = useTranslation('chat');
  const { isSubmitButtonPinned } = useChatInputStore(state => ({
    isSubmitButtonPinned: state.isSubmitButtonPinned,
  }));
  const isAlfredEverywhere = config?.alfredEverywhere;

  const submitButton = isAlfredEverywhere ? (
    <S.AlfredButton
      label={t('chat:askAlfred')}
      size="small"
      variant="primary"
      iconName="Alfred"
      disabled={!inputValue.trim() || isMessagePending}
      $pinned={isSubmitButtonPinned}
    />
  ) : (
    <S.SubmitButton
      data-testid="submit-button"
      iconName="ArrowUp"
      disabled={!inputValue.trim()}
    />
  );

  return (
    <TooltipContainer
      label={t('chat:stopResponse')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
      disabled={!isMessagePending}
    >
      {isMessagePending && !isAlfredEverywhere ? (
        <S.SubmitButton
          data-testid="abort-button"
          iconName="Stop"
          onClick={abortRequest}
        />
      ) : (
        submitButton
      )}
    </TooltipContainer>
  );
};

ChatSubmitButton.Styled = S;
